import axios from 'axios';
import * as HttpConfigs from '../../configs/http';
import {ActionTypes} from '../ActionTypes';
import {endpoints} from '../../configs/http';


import {http} from '../../configs/http';


/**
 * Action creators and middleware for user sign up
 */

const setUpAuthorizedRequest = (data) => {
  return {
    type: ActionTypes.SET_UN_AUTHORIZED_TYPE,
    data: data,
  };
};

export const setUpAuthorized = (data = false) => {
  return (dispatch) => {
    // dispatch pending
    dispatch(setUpAuthorizedRequest(data));
  };
};

const setSeenOnboardingRequest = (data) => {
  return {
    type: ActionTypes.SET_SEEN_ONBOARDING,
    data: data,
  };
};

export const setSeenOnboarding = (data = false) => {
  return async (dispatch) => {
    // dispatch pending
    dispatch(setSeenOnboardingRequest(data));

  };
};
export const getSeenOnboarding = () => {
  console.log('getting');
  return async (dispatch) => {
    // dispatch pending
    console.log('2');

  };
};

const logoutRequest = () => {
  return {
    type: ActionTypes.LOGOUT_REQUEST,
  };
};

export const logout = () => {
  return (dispatch) => {
    // dispatch pending
    dispatch(logoutRequest());
  };
};

const signupRequest = () => {
  return {
    type: ActionTypes.SIGNUP_REQUEST,
    isLoading: true,
    failed: false,
    message: null,
  };
};
/**
 * Action creators adn middleware for logging in
 * registered users into their accounts.
 */

const loginRequest = () => {
  return {
    type: ActionTypes.LOGIN_REQUEST,
    isLoading: true,
    failed: false,
    message: null,
    data: null,
  };
};
const loginSuccess = (data) => {
  return {
    type: ActionTypes.LOGIN_SUCCESS,
    isLoggedIn: true,
    data: data,
  };
};

const signupSuccess = (data) => {
  return {
    type: ActionTypes.SIGNUP_SUCCESS,
    isFetching: false,
    data: data,
  };
};

/**
 * Action creators and middle ware for retrieving already
 * authenticated user info, and decrypting for usage
 */

const getAuthenticatedRequest = () => {
  return {
    type: ActionTypes.GET_AUTHENTICATED_REQUEST,
    isLoading: true,
    hasFetched: false,
    failed: false,
    message: null,
  };
};

const getAuthenticatedSuccess = (data) => {
  return {
    type: ActionTypes.GET_AUTHENTICATED_SUCCESS,
    isLoading: false,
    hasFetched: true,
    failed: false,
    data: data,
  };
};

const getAuthenticatedFailure = (message) => {
  return {
    type: ActionTypes.GET_AUTHENTICATED_FAILURE,
    isLoading: false,
    hasFetched: true,
    failed: true,
    message: message,
  };
};

export const signup = (user) => {
  return (dispatch) => {
    // dispatch pending
    dispatch(signupRequest());

    // make http request
    axios
      .request({
        url: HttpConfigs.url + HttpConfigs.endpoints.SIGNUP,
        method: 'POST',
        data: user,
        headers: HttpConfigs.headers,
      })
      .then(async (resp) => {
        alert(JSON.stringify(resp));
        // if response status is not ok
        // if(!resp.data || !resp.data.status)
        // {
        //     message = resp.data && resp.data.message ? resp.data.message : 'An known error occurred.';
        //     message = resp.data.errors ? resp.data.errors[0] : message;
        //     dispatch( signupFailure( message ) );
        //     return;
        // }
        //
        // // validata user json web token presence
        // if(!resp.data.token)
        // {
        //     message = resp.data && resp.data.message ? resp.data.message : 'Something seems to have gone wrong on our, end please try again in a moment.';
        //     dispatch( signupFailure( message ) );
        //     return;
        // }
        //
        // // save the loggedin user's token and basic info
        // try
        // {
        //     // fab new user
        //     let user = Object.assign( {}, resp.data.data, {
        //         token: resp.data.token
        //     });
        //
        //     // store token in local storage
        //     await asyncStore( STORE_KEYS.AUTH_USER, user );
        //
        //     /**
        //      * Here we will install the referrer code if
        //      * it matches the the install referrer
        //      * we will only store the referral code if it matches the
        //      * the install code. This assumes the install
        //      * code has been used on this device.
        //      */
        //     let storedReferrer = await asyncGet( STORE_KEYS.REFERRER );
        //     let installReferrer = Platform.select({
        //         android: RNDeviceInfo.getInstallReferrer(),
        //         ios: storedReferrer
        //     });
        //     if( user.referred_user && installReferrer == storedReferrer){
        //         await asyncStore( STORE_KEYS.REFERRER, storedReferrer );
        //     }
        //
        //     // dispatch signup success
        //     setTimeout(() => { dispatch(  signupSuccess( user ) ); }, 200);
        // }catch(err){
        //     let message = err && err.message ? err.message : 'An unknown error occured.';
        //     dispatch( signupFailure(message) );
        // }
      })
      .catch((err) => {

          console.log(err);


        // let message = err && err.message ? err.message : 'An unknown error occured.';
        //
        // if(err.response && err.response.data && err.response.data.errors){
        //     message = err.response.data.errors[0];
        // }
        //
        // if(message.toLowerCase().indexOf('status code') != -1){
        //     message = 'An error occured on the server, please try again in a bit.';
        // }

        // dispatch( signupFailure(message) );
      });
  };
};

export const login = (data) => {
  return (dispatch) => {
    // dispatch pending
    dispatch(loginSuccess(data));
  };
};
function loadFromLocal() {
  try {
    const serializedState = localStorage.getItem('authData');
    if (serializedState === null) return undefined
    return JSON.parse(serializedState)
  } catch (e) {
    console.log(e)
    return undefined
  }
}

export const getAuthenticated = () => {
  return async (dispatch) => {
    dispatch(getAuthenticatedRequest());
    try {

      // //dispatch( loginSuccess(user));
      //load user from server
      setTimeout(() => {
        dispatch(doGetAuthUser());
        console.log('hhhhhhsss');
      }, 2000);
    } catch (err) {
      let message =
        err && err.message
          ? err.message
          : 'An unknown error occured, close and launch application again.';
      dispatch(getAuthenticatedFailure(message));
    }
  };
};

/**
 * Action creators adn middleware for fetching the logged in user's information
 * registered users into their accounts.
 */
const getAuthUserRequest = () => {
  return {
    type: ActionTypes.GET_AUTH_USER_REQUEST,
    isFetching: true,
    failed: false,
    message: null,
    data: null,
  };
};

const getAuthUserSuccess = (data) => {
  return {
    type: ActionTypes.GET_AUTH_USER_SUCCESS,
    isFetching: false,
    failed: false,
    data: data,
  };
};

const getAuthUserFailure = (message) => {
  return {
    type: ActionTypes.GET_AUTH_USER_FAILURE,
    isFetching: false,
    failed: true,
    message: message,
  };
};

export const doGetAuthUser = () => {
  return (dispatch, getState) => {
    // return;
    const {auth} = getState();
    console.log(auth);
    // dispatch pending
    dispatch(getAuthUserRequest());
    // make http request
    http
      .get(endpoints.USER_DETAILS)
      .then(async (resp) => {
        console.log(resp);
        // if response status is not ok
        if (!resp) {
          dispatch(getAuthUserFailure('ERROR'));
          return;
        }

        // if(resp.data.deleted)
        // {
        //
        //     dispatch( getAuthUserFailure() );
        //     Alert.alert(
        //         'Your account has been deleted, please contact system\'s admin for support.'
        //     );
        //     // store token in local storage
        //     await asyncStore( STORE_KEYS.AUTH_USER, null );
        //     dispatch(login(null));
        //     return;
        // }

        // save the loggedin user's token and basic info
        try {
          // fab new user
          // let data = Object.assign( {}, auth.data.user, resp);
          //
          //     console.log(data)
          var data = {};
          data.user = resp;
          data.token = auth.data.token;



          // // store token in local storage
          // await asyncStore(STORE_KEYS.AUTH_USER, data);
          // dispatch getAuthUser success
          console.log('new useeee');
          dispatch(getAuthUserSuccess(data));
        } catch (err) {
          let message =
            err && err.message ? err.message : 'An unknown error occured.';
          dispatch(getAuthUserFailure(message));
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch(getAuthUserFailure(err));
      });
  };
};
